import React, { useState } from 'react'
import { ParkingPeriodCategoryComponent } from '../Components/Category/ParkingPeriodCategoryComponent';
import { ParkingComponent } from '../Components/Parking/ParkingComponent';

export const Parking = ({ setLoading, showMessage }) => {
    // ======================================================================
    const [view, setView] = useState('Category');
    const [categoryId, setCategoryId] = useState();
    const [categoryTitle, setCategoryTitle] = useState();

    const [currentPage, setCurrentPage] = useState(1);
    const [version, setVersion] = useState(0);
    const [id, setId] = useState(0);
    // ======================================================================
    return (
        <>
            {view === "Category" ?
                <ParkingPeriodCategoryComponent
                    setLoading={setLoading}
                    showMessage={showMessage}
                    onClickItems={(id, title) => {
                        setCategoryId(id);
                        setCategoryTitle(title);
                        setView("Search");
                    }}
                />
                : <></>}
            {view == "Search" ?
                <ParkingComponent
                    setLoading={setLoading}
                    showMessage={showMessage}
                    categoryId={categoryId}
                    onBackClick={(e) => {
                        setView("Category");
                    }}
                /> : <></>
            }
        </>
    )
}

